<template>
    <div class="cc-recap">
        <div class="cc-recap__main">
            <vouchers/>
            <prices/>
            <custom-message/>
            <note/>
            <consents/>
        </div>
        <div class="cc-recap__footer">
            <div class="minimal-purchase-error text-danger" v-if="minimalPurchase">{{ minimalPurchase }}</div>
            <button class="cc-button cc-button--order" :disabled="minimalPurchase !== ''" @click="$emit('finishOrder')">{{ translations['Finish order'] }}</button>
        </div>
        <div class="cc-recap__order-info" v-if="orderInfo" v-html="orderInfo"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Vouchers from "./Vouchers";
    import Prices from "./Prices";
    import Consents from "./Consents";
    import Note from "./Note";
    import CustomMessage from "@/components/Store919/CustomMessage";

    export default {
        components: {
          CustomMessage,
            Vouchers,
            Prices,
            Consents,
            Note,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                orderInfo: state => state.config.order_info,
                minimalPurchase: state => state.config.minimal_purchase_required,
            }),
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/recap";
    .minimal-purchase-error {
      color: #dc3545;
      text-align: center;
      font-size: 0.875rem;
      font-weight: bold;
      border: 2px solid #dc3545;
      padding: 8px 8px;
      margin-bottom: 8px;
    }
</style>
